module.exports = {
  "argument": [
    {
      "name": "argument",
      "type": [
        "((e: Event) => void)",
        "ClickOutsideBindingArgs"
      ],
      "example": {
        "handler": "(e: Event) => void",
        "closeConditional?": "(e: Event) => boolean",
        "include?": "() => HTMLElement[]"
      },
      "description": {
        "en": "A callback or options object.",
        "ja": "コールバックまたはオプションオブジェクト。",
        "zh-Hans": "回调函数或由状态处理函数组成的对象"
      }
    }
  ],
  "props": [],
  "name": "v-click-outside",
  "directive": true
}